export default __webpack_public_path__ + "static/media/img7.3da19711.PNG";